module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-light-300.0e0b8b74.ttf";